/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.flujosetapas': 'Flujos Etapas',
  'flujosEtapas.agregarFlujosEtapas': 'Crear Flujos Etapas',
  'flujosEtapas.modificarFlujosEtapas': 'Editar Flujos Etapas',
  'flujosEtapas.flujoDescripcion': 'Flujo Descripción',
  'flujosEtapas.etapaDescripcionActual': 'Etapa Actual',
  'flujosEtapas.etapaDescripcionSiguiente': 'Etapa Siguiente',
  'flujosEtapas.empresaId': 'Empresa Id',
  'flujosEtapas.entrada': 'Entrada',
  'flujosEtapas.estado': 'Estado',
  'flujosEtapas.etapaActual': 'Etapa Actual',
  'flujosEtapas.etapaSiguiente': 'Etapa Siguiente',
  'flujosEtapas.flujoEtapaId': 'Flujo Etapa Id',
  'flujosEtapas.flujoId': 'Flujo',
  'flujosEtapas.salida': 'Salida',
  'flujosEtapas.verFlujosEtapas': 'Ver Flujos Etapas',
  'flujosEtapas.AdvertenciaEliminarFlujo': 'Está seguro que desea eliminar el registro seleccionado?. Esta accion no puede deshacerse.',
  'flujoEtapa.EtapasInicialCreadaEliminacion': 'No es posible eliminar el registro, se debe tener un registro con etapa  inicial en creada.',
  'flujoEtapa.EtapasInicialCreadaEdicion': 'No es posible editar el registro, se debe tener un registro con etapa  inicial en creada.',
  'flujoEtapa.EtapasInicialCreadaEstado': 'No es posible editar el registro, se debe tener un registro activo con etapa  inicial en creada.',
};
